
import * as React from "react";
import { HashRouter, Routes, Route, Link } from "react-router-dom";
import Preview from "./preview/Preview";
import { Privacy } from "./privacy/Privacy";
import Project from "./project/Project";
import Projects from "./projects/Projects";
import Support from "./support/Support";
import Home from "./Home";
import Exports from "./exports/Exports";
import StoryPreview from "./preview/StoryPreview";

function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page of the app</Link>
      </p>
    </div>
  );
}


const Router = () => {
    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/project/:id" element={<Project />} />
                <Route path="/exports/:id" element={<Exports />} />
                <Route path="/preview">
                    <Route path=":id" element={<Preview />} />
                    <Route path="*" element={<NoMatch />} />
                </Route>
                <Route path="/story">
                    <Route path=":id" element={<StoryPreview />} />
                    <Route path="*" element={<NoMatch />} />
                </Route>
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/support" element={<Support />} />
            </Routes>
        </HashRouter>
    );
}

export default Router;